import { SiteCardSpec } from "../model/common";

export const applyCss = () => {
  const hostEl = document.querySelector("dsy-sidebar");
  const shadowRoot = hostEl?.shadowRoot;
  if (!shadowRoot) return;

  const sideBarContainer = shadowRoot.querySelector(".sidebar-slot-container") as HTMLElement;
  if(sideBarContainer){
    sideBarContainer.style.paddingLeft="24px";
    sideBarContainer.style.paddingRight="24px";
  }

  const sideBarHeaderContainer = shadowRoot.querySelector(".sidebar-header-container") as HTMLElement;
  if (sideBarHeaderContainer) {
      sideBarHeaderContainer.style.boxShadow = "none";
      sideBarHeaderContainer.style.borderBottom = "1px solid #C2CDDD"
      sideBarHeaderContainer.style.margin= "0";
  }

  shadowRoot
    .querySelector(".sidebar-header-container > div")
    ?.classList.remove("sidebar-header-content");
  const sideBarHeader = shadowRoot.querySelector(
    ".sidebar-header-container > div"
  ) as HTMLElement;
  if (sideBarHeader) {
    sideBarHeader.style.padding = "0rem 1rem";
    sideBarHeader.style.fontWeight = "700";
    sideBarHeader.style.fontSize = "16px";
    sideBarHeader.style.lineHeight = "2rem";
    sideBarHeader.style.fontFamily = "var(--neutral-font-family-bold)";
  }

  const iconEL = shadowRoot?.querySelector("dsy-button");
  const iconClose = iconEL?.shadowRoot
    ?.querySelector(".right")
    ?.querySelector("dsy-icon")
    ?.shadowRoot?.querySelector("div");
  const icon = iconEL?.shadowRoot?.querySelector('button');
  if(icon){
    icon.style.width = "32px";
    icon.style.height = "32px";
    icon.style.borderRadius= "999px";
    icon.style.background = "var(--neutrals-neutral-lightest, #F7F8FB)";
    icon.style.padding="8px";
    icon.style.justifyContent = "center";
  }

  if (iconClose) {
    iconClose.style.width = "9px";
    iconClose.style.height = "9px";
    iconClose.style.color = "var( --secondary-secondary-base, #5738FF)";
  }

  const showSiteEL = document.querySelectorAll("dsy-button");
  showSiteEL?.forEach((shadow: any) => {
    const buttonShadow = shadow.shadowRoot.querySelector(
      "button"
    ) as HTMLElement;
    if (!buttonShadow) return;
    if (buttonShadow) {
      buttonShadow.style.fontFamily = "var(--neutral-font-family-bold)";
      buttonShadow.style.fontWeight = "700";
    }
  });
};

export const showMoreCss = () => {
  const showMoreEl = document.querySelector("dsy-button");
  const shadowRoot = showMoreEl?.shadowRoot;
  if (!shadowRoot) return;

  const buttonShadow = shadowRoot.querySelector("button") as HTMLElement;

  if (buttonShadow) {
    buttonShadow.classList.remove('link-variant');
    buttonShadow.style.fontFamily = "var(--neutral-font-family-bold)";
    buttonShadow.style.fontWeight = "700";
    buttonShadow.style.backgroundColor = "transparent";
    buttonShadow.style.textTransform = "none";
    buttonShadow.style.textDecoration = "none";
    buttonShadow.style.color = "var( --secondary-secondary-base, #5738FF)";
    buttonShadow.style.fontSize = "16px";
    buttonShadow.style.fontStyle = "normal";
    buttonShadow.style.fontWeight = "700";
    buttonShadow.style.lineHeight = "16px";
  }
};

export const applyBoxCss = (value: string, actualSite: SiteCardSpec | undefined) => {
  document
    .querySelectorAll<HTMLInputElement>('input[type="radio"]')
    .forEach((radio) => {
      if (radio.checked && value && radio.id === `${actualSite?.siteName}${actualSite?.event_node_index}${actualSite?.index}`) {
        radio.closest("#siteCard")?.classList.remove("box");
        radio.closest("#siteCard")?.classList.add("box-clicked");
      } else {
        radio.closest("#siteCard")?.classList.remove("box-clicked");
        radio.closest("#siteCard")?.classList.add("box");
      }
    });
};